import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Footer from '../components/molecules/Footer';
import Transition from '../components/atoms/Transition';

import GlobalStyles from '../components/atoms/GlobalStyles';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from '../utils/styling';
import LargeHeader from '../components/molecules/LargeHeader';
import SmallHeader from '../components/molecules/SmallHeader';

const Holder = styled.div`
  width: 100%;
  overflow: hidden;
`;

const Main = styled.main`
  width: 100%;
  margin-top: 4rem;
  @media(${props => props.theme.breakpoints.md}) {
    margin-top: 0;
  }
`;

class Index extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Holder>
          <GlobalStyles/>
          <div id="top"/>
          <SmallHeader/>
          <LargeHeader/>
          <Transition location={this.props.location}>
            <Main>{this.props.children}</Main>
          </Transition>
          <Footer/>
        </Holder>
      </ThemeProvider>
    )
  }
}


Index.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Index;
